import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import setSentryContext from '../tracking/sentry/setSentryContext';

const sentryEnabled = process.env.SENTRY_ENABLED === 'true';
const sentryEndpoint = process.env.SENTRY_ENDPOINT;

if (sentryEnabled) {
  const { environment, app_version } = analyticsDataLayer;
  Sentry.init({
    dsn:          sentryEndpoint,
    release:      app_version,
    environment,
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
  });

  window.Sentry = Sentry;
  setSentryContext();
}
